letterAdjust.x = 5;
letterAdjust.scale = 0.9;
letterAdjust.svg.left = 17.5 + '%';

var font = {
    "0": "M138 -118v1035l148 148h426l148 -148v-1035l-148 -148h-426zM380 -25h239v849h-239v-849z",
    "1": "M138 -25h102v747h-102v125l175 218h167v-1090h102v-241h-444v241z",
    "2": "M140 20l480 642v162h-239v-102h-241v195l147 148h427l147 -148v-337l-455 -605h214v102h241v-343h-721v286z",
    "3": "M138 77h242v-102h239v305h-239v239h239v305h-239v-102h-242v195l148 148h426l148 -148v-466l-52 -52l52 -51v-466l-148 -148h-426l-148 148v195z",
    "4": "M79 129v241l384 695h281v-695h101v-241h-101v-154h101v-241h-443v241h101v154h-424zM353 370h150v273z",
    "5": "M141 77h241v-102h239v378h-480v712h722v-241h-481v-231h333l148 -147v-564l-148 -148h-426l-148 148v195z",
    "6": "M138 -118v1035l148 148h426l148 -148v-195h-241v102h-239v-305h332l148 -148v-489l-148 -148h-426zM380 -25h239v305h-239v-305z",
    "7": "M141 -25h120l360 747v102h-239v-102h-241v343h722v-399l-335 -691h93v-241h-480v241z",
    "8": "M138 -118v466l52 51l-52 52v466l148 148h426l148 -148v-466l-52 -52l52 -51v-466l-148 -148h-426zM380 -25h239v305h-239v-305zM380 519h239v305h-239v-305z",
    "9": "M138 77h242v-102h239v305h-333l-148 147v490l148 148h426l148 -148v-1035l-148 -148h-426l-148 148v195zM380 519h239v305h-239v-305z",
    "A": "M117 -266l127 1331h329l127 -1331h-151l-38 393h-206l-37 -393h-151zM320 276h178l-61 639h-57z",
    "B": "M141 -266v1331h507l76 -74v-517l-76 -75l76 -74v-517l-76 -74h-507zM292 -117h282v442h-282v-442zM292 474h282v441h-282v-441z",
    "C": "M141 -192v1183l75 74h432l76 -74v-177h-150v101h-282v-1032h282v99h150v-174l-76 -74h-432z",
    "D": "M141 -266v1331h507l76 -74v-1183l-76 -74h-507zM290 -117h284v1032h-284v-1032z",
    "E": "M141 -266v1331h583v-150h-432v-441h282v-149h-282v-442h432v-149h-583z",
    "F": "M141 -266v1331h583v-150h-432v-441h282v-149h-282v-591h-151z",
    "G": "M141 -192v1183l75 74h432l76 -74v-177h-150v101h-282v-1032h282v442h-141v149h291v-666l-76 -74h-432z",
    "H": "M141 -266v1331h151v-591h282v591h150v-1331h-150v591h-282v-591h-151z",
    "I": "M141 -266v1331h151v-1331h-151z",
    "J": "M89 -18h151v-99h282v1182h149v-1257l-74 -74h-433l-75 74v174z",
    "K": "M141 -266v1331h149v-486l264 486h169l-290 -539l290 -792h-159l-227 616l-47 -85v-531h-149z",
    "L": "M141 -266v1331h149v-1182h433v-149h-582z",
    "M": "M141 -266v1331h151l215 -613l217 613h149v-1331h-149v881l-217 -612l-215 612v-881h-151z",
    "N": "M141 -266v1331h151l282 -871v871h150v-1331h-150l-282 870v-870h-151z",
    "O": "M141 -192v1183l75 74h432l75 -74v-1183l-75 -74h-432zM290 -117h284v1032h-284v-1032z",
    "P": "M141 -266v1331h507l76 -74v-592l-76 -74h-356v-591h-151zM292 474h282v442h-282v-442z",
    "Q": "M141 -193v1184l75 74h433l75 -74v-1184l-75 -75h-51l62 -138h-97l-63 138h-284zM292 -117h282v1032h-282v-1032z",
    "R": "M141 -266v1331h507l76 -74v-592l-76 -74l76 -591h-151l-75 591h-208v-591h-149zM290 474h284v442h-284v-442z",
    "S": "M141 -18h149v-99h284v442h-358l-75 74v592l75 74h432l76 -74v-177h-150v101h-284v-441h358l76 -75v-591l-76 -74h-432l-75 74v174z",
    "T": "M128 915v150h583v-150h-217v-1181h-151v1181h-215z",
    "U": "M141 -192v1257h149v-1182h284v1182h150v-1257l-76 -74h-432z",
    "V": "M129 1065h151l131 -1182h17l134 1182h150l-150 -1331h-282z",
    "W": "M132 1065h150l53 -732l126 732h49l126 -732l54 732h148l-96 -1331h-156l-100 581l-100 -581h-157z",
    "X": "M137 -266l216 665l-216 666h149l142 -435l142 435h150l-217 -666l217 -665h-150l-142 435l-142 -435h-149z",
    "Y": "M122 1065h158l134 -411l133 411h158l-216 -666v-665h-150v665z",
    "Z": "M138 -117l433 1032h-433l41 150h500l41 -150l-431 -1032h431l-41 -149h-500z"
};
var font_size = 23,
    panel_Hor_Adjustment = 0,
    font_Top_Adjustment = -13,
    tracking = 4,
    middleSplitAdjustment = -0.75,
    middleSpreadAdjustment = {
        left: 1,
        right: 1
    },
    small_Caps_Adjustment = {
        vertical: -165,
        horizontal: 0,
        scale_width: 0,
        scale_height: 0,
    },
    // Colors are in order like this...  home: [ inside, outline, outline2, outline3 ]
    colors = {
        characters: {
            home: [
                "#FFFFFF", // white
            ],
            away: [
                "#e31837", // red
            ]
        },
        numbers: {
            home: [
                "#FFFFFF", // white
            ],
            away: [
                "#e31837", // red
            ]
        }
    },
    outlines = {
        characters: {
            width: 0
        },
        numbers: {
            width: 2
        }
    },
    special_Character_Adjustments = {
        period: {
            vertical: -2.5, // this moves it up from the bottom
            horizontal: 1,
            scale_width: 15.5,
            scale_height: 15.5,
        },
        hyphen: {
            vertical: -6,
            horizontal: -5.5,
            scale_width: 0,
            scale_height: -3,
        },
        apostrophe: {
            vertical: 0.25, // this is backwards
            horizontal: -1,
            scale_width: 0,
            scale_height: 0,
        }
    },
    number_Adjustments = {
        top: 11.5,
        left: -8,
        width: 100,
        height: 85,
        middle_Space: 5,
    };
